<script>
import moment from 'moment'
import * as Currency from '../../../../static/js/currency'

const TITLES_BY_TYPE = {
  'team-challenge': 'Team Challenge',
  jackpot: 'Jackpot',
  'jackpot-2-challenge': 'Personal Jackpot',
  'jackpot-3': 'Personal Jackpot',
  'step-challenge-2': 'Step Challenge',
  'step-challenge-3': 'Step Challenge',
  'step-challenge-4': 'Step Challenge',
  sweepstakes: 'Sweepstakes Challenge'
};

export default {
  computed: {
    isBigContainer: function() {
      return this.challengeList.length === 1;
    },
    challengeList: function() {
      return filterChallengesByType(this.$store.state.fullFilteredChallengeList, this.challengeType)
    }
  },
  methods: {
    getSubtitle: function(challenge) {
      return challenge.goal_text
    },
    dateRangeOf: function (challenge) {
      return moment(challenge.start_date).format('MMM DD, YYYY');
    },
    getBetValue: function(challenge) {
      var currencySymbol = Currency.HW.currency.getSymbol(challenge.top_price_currency);
      var value = parseFloat((challenge.bet_amount / challenge.installments).toFixed(2)).toLocaleString();

      return currencySymbol.concat(value, ` / mo for ${challenge.installments} mos`);
    },
    getTeamSize: function(challenge) {
      return challenge.team_size;
    },
    getType: function(challenge) {
      return TITLES_BY_TYPE[challenge.challenge_type]
    }
  }
}

export function filterChallengesByType(list, type) {
  return list.filter(function(challenge) {
    return !challenge.is_org_challenge && challenge.challenge_type.includes(type)
  });
}

export function parsedPotValue(currency, value) {
  return Currency.HW.currency.getSymbol(currency).concat(parseInt(value).toLocaleString());
}

</script>
